import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateItemSelected } from '../../../../store/actions/menuActions'
import { useLocation, useNavigate } from 'react-router-dom'
import List from '@mui/material/List'
import ListMenu from '../../../commom/ListMenu'
import { toggleAlertModule } from '../../../../store/actions/alert.actions'
import { updateFilter } from '../../../../store/actions/filter.actions'

const Menu = () => {
  const alertSave = useSelector(state => state?.alert?.save || {})
  const menu = useSelector(state => state.menu.items || [])
  const selected = useSelector(state => state.menu?.selected || {})
  const module = useSelector(state => state.filter?.moduleName || '')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const redirect = useCallback((redirectTo, data) => {
    navigate(redirectTo)
    dispatch(updateItemSelected(data))
    if (redirectTo.indexOf('users') > -1) {
      dispatch(updateFilter('user', {}));
    }
  }, [])

  const handleClick = useCallback((redirectTo, data) => {
    if (alertSave && alertSave.mode) {
      dispatch(toggleAlertModule(
        true,
        alertSave.module,
        alertSave.mode,
        alertSave.onSave,
        () => {
          redirect(redirectTo, data)
        }
      ))
    } else {
      redirect(redirectTo, data)
    }
  }, [alertSave])

  useEffect(() => {
    if (module) {
      if (pathname.indexOf(`/dashboard/${module}`) === -1) {
        dispatch(updateFilter(module))
      }
    }
  }, [module, pathname])

  const clss = (selected, bg = true) => {
    let className = 'text-primary-foreground'
    if (selected) {
      className = 'text-primary font-bold'
      if (bg) {
        className= 'bg-primary text-primary-foreground'
      }
    } else {
      className = 'text-muted-foreground'
      if (bg) {
        className = 'bg-muted text-muted-foreground'
      }
    }
    return className
  }

  return (
    <div className='section-menu overflow-y-auto'>
    <List>
      <ListMenu
        id="menu-app"
        items={menu.map((item) => ({
          ...item,
          classNameIcon: `rounded-full size-4 p-2 ${clss(selected.item === item.id)}`,
          classNameText: clss(selected.item === item.id, false),
          collapseOpen: true,
          className: '',
          onClick: () => handleClick(item.redirectTo, { item: item.id }),
          items: item.items ? item.items.map((subItem) => ({
            ...subItem,
            collapseOpen: true,
            classNameIcon: `rounded-full size-4 p-2 ${clss(selected.item === item.id && selected.subItem === subItem.id)}`,
            classNameText: clss(selected.item === item.id && selected.subItem === subItem.id, false),
            onClick: () => handleClick(subItem.redirectTo, { item: item.id, subItem: subItem.id }),
            items: subItem.items ? subItem.items.map((subSubItem) => ({
              ...subSubItem,
              classNameIcon: `rounded-full size-4 p-2 ${clss(selected.item === item.id && selected.subItem === subItem.id)}`,
              classNameText: clss(selected.item === item.id && selected.subItem === subItem.id, false),
              onClick: () => handleClick(subSubItem.redirectTo, { item: item.id, subItem: subItem.id, subSubItem: subSubItem.id })
            })) : []
          })) : []
        }))}
      />
    </List>
    </div>
  )
}

export default Menu